export default {
  getTemplatesLoading(state) {
    return state.isLoading;
  },

  getTemplatesError(state) {
    return state.error;
  },

  getShipmentTemplates(state) {
    return state.shipmentTemplates;
  },

  getBulkTemplates(state) {
    return state.bulkTemplates;
  },

  getDealTemplates(state) {
    return state.dealTemplates;
  },
};
